import { Flatfile } from "@flatfile/api";
import { feedbackSheet } from "./sheet";

export const workbook: Flatfile.CreateWorkbookConfig = {
  name: "Bulk import Feedback",
  namespace: "Feedback",
  sheets: [feedbackSheet],
};